import React, { useContext } from 'react';
import styles from './FilterSelectorItem.module.scss';
import { SFCheckbox } from 'sfui';
import { AppearanceContext } from 'ui-smartforce-settings';
import { WidgetFilterOption } from '../../../../Models';

export interface FilterSelectorItemProps {
  option: WidgetFilterOption;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export const FilterSelectorItem = ({
  option,
  checked,
  onChange
}: FilterSelectorItemProps): React.ReactElement<FilterSelectorItemProps> => {
  const { themeType } = useContext(AppearanceContext);

  return (
    <div className={styles.filterSelectorItem}>
      <div
        style={{
          backgroundColor: option.color[themeType]
        }}
        className={styles.circleColor}
      />

      <span className={styles.label}>{option.label}</span>

      <SFCheckbox
        checked={checked}
        onChange={(_e, checked) => onChange(checked)}
        role="checkbox"
        aria-label={option.label}
        aria-checked={checked}
      />
    </div>
  );
};
